import { Injectable, Injector } from '@angular/core';



import { $frontendTypes } from './Addresses.frontend.types'

@Injectable({ providedIn: 'root' })
export class Addresses_FrontendFlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public Addresses: Addresses_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
